import _ from 'lodash'
import AppModule from '@/modules/app-router/model/AppModule'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

export enum ChangeType {
    Fixed = 'Fixed',
    Added = 'Added',
    Changed = 'Changed',
    Removed = 'Removed',
    Deprecated = 'Deprecated',
    Security = 'Security',
}

/**
 * Cambio de versión
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ReleaseChange {
    public id = 0
    public type: ChangeType
    public title = ''
    public comment = ''

    /**
     * Id único temporal generado por la aplicación
     *
     * @var { string }
     */
    public readonly tempId = _.uniqueId('release_change_')

    /**
     * Módulos de la aplicación modificados en el cambio
     *
     * @var { AppModule[] }
     */
    public modules: AppModule[] = []

    /**
     * Crea una entidad a partir del objeto plano serializado
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const change =  Object.assign(new this(), {
            id: data.id,
            type: data.type,
            title: data.title,
            comment: data.comment,
        })

        if (Array.isArray(data.modules)) {
            change.modules = data.modules.map(m => AppModule.deserialize(m))
        }

        return change
    }

    /**
     * Crea un objeto plano de la entidad listo para ser enviado
     * a la API
     */
    public serialize () {
        return {
            type: this.type,
            title: this.title,
            comment: this.comment,
            modules: this.modules.map( m => m.id ),
        }
    }
}
